module.exports = __webpack_public_path__ + "img/profile-circle.5f407fa7.svg";